import React from "react";
import Breadcrumb from "../../common/Breadcrumb";
import PackageSidebarWrap from "./PackageSidebarWrap";

function PackageSIdebar() {
  
  return (
    <>
      <Breadcrumb name="Package Sidebar" />
      <PackageSidebarWrap />
    </>
  );
}

export default PackageSIdebar;
